import type { ReactNode } from 'react';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen" data-ai-id="app-layout">
      <main className="w-full max-w-none px-5 pb-6 pt-5" data-ai-id="app-layout-main">
        {children}
      </main>
    </div>
  );
}
